var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "info-panel" }, [
    _c("i", {
      staticClass: "big angle double left icon",
      on: {
        click: function($event) {
          return _vm.changePanelState()
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: " metadata-container" },
      [
        _vm.observationsDetail != null
          ? _c("observation-metadata-info-panel-component", {
              staticClass: "observation-details",
              attrs: { observationsDetail: _vm.observationsDetail }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }